<template>
  <prime-overlay ref="overlayElement" class="overlay-panel" :class="{ 'animated-panel': useTransition }">{{
    overlayState.text
  }}</prime-overlay>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import PrimeOverlay from 'primevue/overlaypanel';
import type { Overlay } from '@store/modules/layout';

withDefaults(
  defineProps<{
    /** Wether to use transition effect for the overlay panel */
    useTransition?: boolean;
  }>(),
  { useTransition: true },
);

const store = useStore();
const overlayElement = ref<PrimeOverlay>();
const overlayState = computed<Overlay>(() => store.state.layout.overlay);

watch(overlayState, ({ triggeringEvent, text }) => {
  if (triggeringEvent && text) overlayElement.value?.show(triggeringEvent);
  else overlayElement.value?.hide();
});
</script>

<style scoped>
/* global styling needed since the overlay element is teleported to the body */
:global(.overlay-panel) {
  max-width: 50%;
  -webkit-transition: none !important;
  -moz-transition: none !important;
  -o-transition: none !important;
  transition: none !important;
}
:global(.animated-panel) {
  -webkit-transition: transform 0.5s cubic-bezier(0, 0, 0.2, 1), opacity 0.12s cubic-bezier(0, 0, 0.2, 1) !important;
  -moz-transition: transform 0.5s cubic-bezier(0, 0, 0.2, 1), opacity 0.12s cubic-bezier(0, 0, 0.2, 1) !important;
  -o-transition: transform 0.5s cubic-bezier(0, 0, 0.2, 1), opacity 0.12s cubic-bezier(0, 0, 0.2, 1) !important;
  transition: transform 0.5s cubic-bezier(0, 0, 0.2, 1), opacity 0.12s cubic-bezier(0, 0, 0.2, 1) !important;
}
:global(.animated-panel.p-overlaypanel-enter-active) {
  transition-delay: 250ms !important;
}
:global(.animated-panel.p-overlaypanel-leave-active) {
  transition-delay: 100ms !important;
}
</style>
